import React from 'react';
import { View,  StyleSheet, Image, ActivityIndicator, ImageBackground, Platform, KeyboardAvoidingView, TouchableOpacity } from 'react-native';

import {Button } from 'react-native-paper'
import AsyncStorage from '@react-native-community/async-storage';
import { Snackbar, TextInput, Surface } from 'react-native-paper';
// import BackHandlerAndroid from './../AndroidBackHandler';
import {  dispatchClearRegistation, verifyOtpForRegistration, dispatchClearRegistrationOtpVerify, registation} from './../../store/actions';
import { connect } from 'react-redux';
// import {  dispatchClearRegistation, verifyOtpForRegistration, dispatchClearRegistrationOtpVerify, registation } from './../../store/actions';
// import { firebase, getDeviceInfo, deviceHeight, appVersion, firebaseLogEvent } from './../Utils';
import Timer from './../../components/timer';
// import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
// import OTPInputView from '@twotalltotems/react-native-otp-input';
import Toaster from './../../components/snackBar_toaster';
import { Text , Styles} from "./../../components/UI-Components" ;

// import Colors from '../Colors';
import OtpInput from 'react-otp-input';

class TimerComponent extends React.Component {

    shouldComponentUpdate() {
        return false;
    }

    render() {
        return (
            <Timer {...this.props} />
        )
    }
}



// const isIos = Platform.OS === "ios";
class OtpScreen extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            snackbarMsg: '',
            _deviceInfo: null,
            hideResendBtn: true,
            code: undefined,
            showToast: false,
            toasterMessage: "",
        }
    }

    componentDidMount() {
    //    if(!isIos) this.startListeningForOtp();
    }

    componentWillUnmount() {    
        // this.props.clearAllDeviceInfo();
        // this.props.dispatchClearRegistation();
        // this.props.dispatchClearRegistrationOtpVerify();
    }

     componentDidUpdate(prevProps) {

        let goToSelectSubject = true;

        // if(prevProps.appVersion !== this.props.appVersion) {
        //     if(this.props.appVersion) {                             
        //         const {android, ios} = this.props.appVersion || {};
        //         const version = isIos ? ios : android;
        //         if(version && appVersion !== version) {
        //             goToSelectSubject = false;
        //             this.props.navigation.navigate('UpdateAppScreen');                    
        //         }        
        //     }
        // }

        if (this.props.authToken !== prevProps.authToken) {
            if (this.props.authToken) {
                this._storeData(this.props.authToken);
                // this.refs.toast.show('Successfully logged in', 1000)           
                // const data = await getDeviceInfo();

                // firebaseLogEvent('registration_completed', {});
                
                // RNOtpVerify.removeListener(); 
                setTimeout(() => {
                    this.setState({code: undefined});
                }, 2000);
                // if (data) {
                //     // this.props.sendDeviceInfoWithFCMToken(data, true);
                // }
                
                if(goToSelectSubject) {
                    setTimeout(() => {
                        this.props.history.push('/Home');
                    }, 1500)   
                }         
            
            }
        }

        if (prevProps.errInfo !== this.props.errInfo) {
            if (this.props.errInfo) {
                this.showToaster(this.props.errInfo)
                this.setState({code: undefined});
            }
        }

    }
    showToaster = (msg) => {
        this.setState({
          showToast: true,
          toasterMessage: msg
        })
      }

    startListeningForOtp = () => {
        // RNOtpVerify.getOtp()
        // .then(p => RNOtpVerify.addListener(this.otpHandler))
        // .catch(p => console.log(p));
     }
  

    otpHandler = (message) => {
        const otp = /(\d{6})/g.exec(message)[1];
        this.setState({ code: otp }, () => {
            setTimeout(() => {
                this.props.verifyOtpForRegistration(otp);
            }, 400);
        });                          
    }


   


    resendOTP = () => {
    
        const {
            username=null,
            first_name=null,
            last_name=null,
            phone=null,
            email=null,
        } = this.props.registrationResponse || {};

        const userData = {
            userName: username,
            firstName: first_name,
            lastName: last_name,
            email, 
            phone
        }

        if (username && first_name && last_name && phone) {
            this.setState({
                hideResendBtn: true
            })
            this.props.registation(userData);
        } else {
            setTimeout(() => {
                // navigation.navigate.goBack();
            }, 600);
        }
    }

    _storeData = async (key) => {
        try {
            await AsyncStorage.setItem('authKey', key);
            const value = await AsyncStorage.getItem('authKey');     
            if (value !== null) {
                // We have data!!
                // console.log(value, 'stored value');
            }
        } catch (error) {
            // Error saving data
            // console.log(error, 'async error');
        }

    }

    // _onFulfill = (code) => {
    //     this.setState({
    //         otp: code
    //     })
    //     this.props.verifyOtpForRegistration(code);
    // }

    handleChange = otp => this.setState({ 
        code: otp
     },() => {

         const { code } = this.state;
         let _otp =[];
         _otp.push({..._otp, Otp: `${code}`});
         if(_otp[0].Otp.length === 6){
            if (code && String(code).length === 6 ) {
                return this.props.verifyOtpForRegistration(code);
            }
            this.showToaster('Incorrect otp')
        }
     }
     );

   

    render() {
        // console.log(this.props, 'from registration verify');
        const { visible, code } = this.state;
        const { resendOtpLoading, loading } = this.props;

        return (

            <div className='loginBox'
            style={{display: 'flex', 
            justifyContent: 'center',
             alignItems: 'center'
            }}
            >
 
            <div style={{
                
                // flex:1,justifyContent:'center', paddingVertical: 30
                flexDirection: 'column',
                display: 'flex',
                maxWidth: 300,
                padding: 25,
                justifyContent: 'center',
                // paddingVertical: 30,
                borderRadius: 5,
                boxShadow: '0px 1px 1px 1px rgba(0,0,0,0.6)',  
                
                }}>
            <>
    
                <View style={{justifyContent:'center',alignItems:'center'}}>
                    <Image source={require('./../../assets/otp_phone.png')} style={{width:90,height:80}} />
                    </View>
                    <Text style={{ color: '#222', fontSize: 16, textAlign: 'center',fontWeight:'600',marginTop:15 }}>Waiting For OTP </Text>
                    <View style={{flexDirection:'row',alignItems:'center',justifyContent:'center',marginTop: 5}}>
                        <Text style={{ color: '#222', fontSize: 13, textAlign: 'center', }}>
                        {/* OTP sent to mobile number   */}
                        OTP sent to  your register email
                    </Text>
                    {/* <Text style={{marginLeft:5,fontSize: 13,}}>{this.props.navigation.getParam('mobile')}</Text> */}
                </View>
                    {/* <Text style={{ color: '#222', fontSize: 25, textAlign: 'center' }}>Verification Code</Text> */}
                    {/* <Text style={{ color: '#222', fontSize: 16, marginTop: 15, textAlign: 'center', color: '#29355f', marginHorizontal: 30 }}>
                            OTP has been sent to your mobile number.
                                Please verify
                    </Text> */}
                        <View style={{justifyContent:'center', alignItems:'center',  paddingVertical: 20}}>
                    {/* <OTPInputView
                            //  ref="codeInputRef1"
                            style={{width: '70%', height: 100,}}
                            ref={x => this.otpInput = x}
                            code={this.state.code}
                            //  className={'border-b'}
                            //  space={5}
                            //  size={30}
                            //  codeLength={6}
                            //  inputPosition='center'
                            //  activeColor='#29355F'
                            //  inactiveColor='#29355F'
                                autoFocusOnLoad={true}
                            //  ignoreCase={true}
                            //  onCodeChanged
                                codeInputFieldStyle={styles.underlineStyleBase}
                                codeInputHighlightStyle={styles.underlineStyleHighLighted}
                                onCodeFilled ={(code) => this._onFulfill(code)}
                            

                                
                            /> */}
                            <OtpInput
                            onChange={this.handleChange}
                            numInputs={6}
                            value={this.state.code}
                            // separator={<span>-</span>}
                            shouldAutoFocus
                            containerStyle={{
                                marginTop: 24,
                                marginBottom: 24
                            }}
                            inputStyle={{
                                padding: 12,
                                marginLeft: 8,
                                marginRight: 8
                            }}
                            hasErrored
                            isInputNum
                            />
                    </View>
                    <Button style={styles.goButton}
                                disabled={loading || this.props.status ? true : false}
                            //  disabled={this.otpInput && this.otpInput.state && this.otpInput.state.digits && this.otpInput.state.digits.length >=6 ? false : true }
                                mode="contained"
                                onPress={() => {
                                
                                // const value = this.otpInput.getDigits();
                                // const _otp = value && value.length > 0 &&  value.toString().split(",").join("");
                                
                                    this.props.verifyOtpForRegistration(code);
                                
                                    
                                //  this.showToaster('Incorrect otp')                                                      
                                    
                            }}
                            loading={this.props.loading  ? true : false}
                            >
                                Proceed
                        </Button>
                        <View>
                        {
                                loading || resendOtpLoading ?

                                    (
                                        <View style={{ justifyContent: 'center', alignItems: 'center', flex: 1 }}>
                                            {/* <ActivityIndicator />
                                            {
                                                loading && (<Text style={{ textAlign: 'center', color: '#1a2b63' }}>
                                                    'Verifying Please Wait....'
                                                </Text>)
                                            } */}

                                            {
                                                resendOtpLoading && (<Text style={{ textAlign: 'center', color: '#1a2b63' }}>
                                                    'Please Wait....'
                                        </Text>)
                                            }

                                        </View>
                                    )

                                    : null
                            }
                        </View>
                    <View >
                            {
                                this.state.hideResendBtn &&
                                <View style={{flex: 1, justifyContent: 'center', alignItems: 'center' ,marginTop: 10}}>

                                <TimerComponent 
                                    style={{ textAlign: "center", }}
                                    timer={1}
                                    onSubmit={() => this.setState({
                                         hideResendBtn: false 
                                    })}
                                />
                            </View>
                            }                                
                        </View>
                        <View style={{marginTop:10}}>
                        <Text style={{ marginBottom: 15, textAlign: 'center',marginTop:5 }}>Didn't you receive verification code</Text>
                        </View>

                        <View style={{marginBottom:20}}> 
                            {
                                !this.state.hideResendBtn &&
                            //  <Button
                            //      disabled={resendOtpLoading || loading}
                            //      style={{ borderRadius: 25 }}
                            //      title={'RESEND OTP'}
                            //      onPress={() => {
                            //          this.resendOTP();
                            //      }}
                            //  />
                            <View style={{justifyContent:'center',alignItems:'center'}}>
                            <TouchableOpacity
                                title={'RESEND OTP'}
                            onPress={() => {
                                        this.resendOTP();
                                    }}>

                            <Text style={{color:'red'}}>Resend OTP</Text>
                        </TouchableOpacity>

                            </View> 
                            }
                        </View>
                        <View>
                        {/* <Snackbar
                            style={{ backgroundColor: '#fff', color: '#222',flex:1,justifyContent:'flex-end' }}
                            visible={this.state.visible}
                            onDismiss={() => this.setState({ visible: false })}
                            action={{
                                label: 'close',
                                onPress: () => {
                                    this.setState({ visible: false })
                                },
                            }}
                        >
                            <Text style={{ color: '#222' }}>{this.state.snackbarMsg}</Text>
                        </Snackbar> */}

                    <Toaster 
                    show={this.state.showToast}
                    message={this.state.toasterMessage}
                    />
                        </View>
            
            </>
            
            

            </div>
                            
                    
            </div>

        )
    }
}

const styles = StyleSheet.create({
    container: {
        borderWidth:3,
        flex: 1,
        justifyContent:'center',
        alignItems: 'center',
        paddingHorizontal: 10,
      },
    mainContainer: {
        // flex: 1,
        // justifyContent: 'center',
        // align/Items: 'center',
        // backgroundColor: '#2f2f2f',
        // paddingBottom:20
    },
    splashBackgroundImage: {
        width: '100%',
        height: '100%',
    },
    borderStyleBase: {
        width: 30,
        height: 45
      },
    
      borderStyleHighLighted: {
        borderColor: "#03DAC6",
      },
    
      underlineStyleBase: {
        width: 30,
        height: 45,
        borderWidth: 0,
        borderBottomWidth: 1,
      },
    
      underlineStyleHighLighted: {
        borderColor: "#03DAC6",
      },
      goButton: {
        minWidth: 50,
        paddingHorizontal: 8,
      //   paddingVertical: 7,
        backgroundColor: Styles.themeColor,
        alignItems: 'center',
        alignSelf: 'center',
        borderRadius: 15,
        color: '#fff'

    }
})

const mapStateToProps = state => ({
    loading: state.verifyOTPForRegistration && state.verifyOTPForRegistration.loading && state.verifyOTPForRegistration.loading,
    err: state.verifyOTPForRegistration && state.verifyOTPForRegistration.error,
    errInfo: state.verifyOTPForRegistration && state.verifyOTPForRegistration.errInfo && state.verifyOTPForRegistration.errInfo.data && state.verifyOTPForRegistration.errInfo.data.message,
    status: state.verifyOTPForRegistration.response && state.verifyOTPForRegistration.response.status && state.verifyOTPForRegistration.response.status,
    firstTimeLogin: state.verifyOTPForRegistration.response && state.verifyOTPForRegistration.response.data && state.verifyOTPForRegistration.response.data.first_time_login && state.verifyOTPForRegistration.response.data.first_time_login,
    authToken: state.verifyOTPForRegistration.response && state.verifyOTPForRegistration.response.data && state.verifyOTPForRegistration.response.data.token && state.verifyOTPForRegistration.response.data.token,
    appVersion: state.verifyOTPForRegistration.response && state.verifyOTPForRegistration.response.data && state.verifyOTPForRegistration.response.data.os_version,
    resendOtpLoading: state.registration && state.registration.loading,
    resendOtpErr: state.registration && state.registration.err,
    // resendOtpResponse: state.registation.response && state.registation.response, 
    registrationResponse: state.registration && state.registration.response && state.registration.response,
})

export default connect(mapStateToProps, {
       dispatchClearRegistation, verifyOtpForRegistration, dispatchClearRegistrationOtpVerify, registation 
    })(OtpScreen);
